import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
} from '@fortawesome/free-solid-svg-icons';
import {
  faGithub,
  faLinkedin,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';

import './Footer.css';

const Footer = () => {
  const { isAuthenticated, logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    window.location.href = '/';
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-block">
          <h3 className="footer-title">Mikołaj Melnyk</h3>
          <p className="line"></p>
          <p className="footer-description">
            Frontend & Full-Stack Developer | Next.js • React • Node.js •
            JavaScript. Tworzę nowoczesne, responsywne strony i aplikacje webowe
            – od landing page’y po projekty z backendem i bazami danych.
          </p>
        </div>

        <div className="footer-block">
          <h4 className="footer-subtitle">Szybkie linki</h4>
          <ul className="footer-links">
            <li>
              <Link to="/">Strona główna</Link>
            </li>
            <li>
              <Link to="/blog">Blog</Link>
            </li>
            <li>
              <Link to="/projects">Projekty</Link>
            </li>

            <li>
              <Link to="/resume">Resume</Link>
            </li>
            <li>
              <Link to="/contact">Kontakt</Link>
            </li>
          </ul>
        </div>

        <div className="footer-block">
          <h4 className="footer-subtitle">Kontakt</h4>
          <p className="contact-footer">
            <span className="contact-item">
              <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
              <span>mikolajmelnyk16@gmail.com</span>
            </span>

            <span className="contact-item">
              <FontAwesomeIcon icon={faPhone} className="contact-icon" />
              <span>+48 888 508 630</span>
            </span>
            <span className="contact-item">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="contact-icon" />
              <span> Rzeszów, Polska</span>
            </span>
          </p>
        </div>

        <div className="footer-block">
          <h4 className="footer-subtitle">Media społecznościowe</h4>
          <div className="social-links">
            <a
              href="https://github.com/Mikolaj1921"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
            >
              <FontAwesomeIcon icon={faGithub} />
            </a>
            <a
              href="https://www.linkedin.com/in/miko%C5%82aj-melnyk-634213335/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
            <a
              href="https://www.instagram.com/melnikmikolai"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-legal">
          <p>
            © {new Date().getFullYear()} Mikołaj Melnyk. Wszystkie prawa
            zastrzeżone.
          </p>
          <div className="legal-links">
            <Link to="/privacy-policy">Polityka prywatności</Link>
            <span className="separator"> • </span>
            <Link to="/terms-of-use">Regulamin</Link>
          </div>
        </div>

        <div className="admin-section">
          {isAuthenticated ? (
            <button onClick={handleLogout} className="auth-btn logout">
              Wyloguj (admin)
            </button>
          ) : (
            <Link to="/admin/login" className="auth-btn login">
              Dla administracji
            </Link>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
